import React, { Component } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import { confirmAlert } from 'react-confirm-alert';
import { toast } from 'react-toastify';
import services from '@C/LiveMemo/_utils/data';
import {
  formatCurrency,
  TableGrid,
  export2Excel,
  export2PDF,
} from '@C/TableGrid';
import DropLoaderLarge from '@C/Utils/DropLoaderLarge';
import { authHeader } from '@H';
const col = [
  {
    name: 'Date',
    key: 'time_stamp',
    sortable: true,
    type: 'date',
  },
  {
    name: 'Customer',
    key: 'customer_name',
  },

  {
    name: 'Product',
    key: 'product_list',
    formatter(props) {
      return (
        <>
          {props.map((item, i) => (
            <React.Fragment key={i}>
              {item.product.name}
              <hr />
            </React.Fragment>
          ))}
        </>
      );
    },
  },
  {
    name: 'Price',
    key: 'product_list',
    formatter(props) {
      return (
        <>
          {props.map((item, i) => (
            <React.Fragment key={i}>
              {item.price.toFixed(2)}
              <hr />
            </React.Fragment>
          ))}
        </>
      );
    },
  },
  {
    name: 'Quantity',
    key: 'product_list',
    formatter(props) {
      return (
        <>
          {props.map((item, i) => (
            <React.Fragment key={i}>
              {item.quantity.toFixed(2)}
              <hr />
            </React.Fragment>
          ))}
        </>
      );
    },
  },
  {
    name: 'Discount',
    key: 'product_list',
    formatter(props) {
      return (
        <>
          {props.map((item, i) => (
            <React.Fragment key={i}>
              {item.discount.toFixed(2)}
              <hr />
            </React.Fragment>
          ))}
        </>
      );
    },
  },
  {
    name: 'Vehicle',
    key: 'vehicle',
  },
  {
    name: 'Payment mode',
    key: 'source',
  },
  {
    name: 'Total amount',
    key: 'all',
    formatter(props) {
      return <>{formatCurrency(props.after_tax)}</>;
    },
  },
];

const enabledActions = [
  {
    action: 'Delete',
    roles: ['Dealer', 'Manager'],
  },
  {
    action: 'Print Memo',
    roles: ['Dealer', 'Manager'],
  },
];

class GeneratedBillList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      liveMemoList: [],
      selectedId: '',
      showModal: false,
      loading: false,
      start_date: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
      end_date: dayjs().format('YYYY-MM-DD'),
      limit: 20,
      offset: 1,
      count: 0,
    };

    this.limitInput = React.createRef();
  }

  componentDidMount() {
    this.getLiveMemoList();
  }

  handlePagination = (e) => {
    this.setState({ offset: e }, function () {
      this.getLiveMemoList();
    });
  };
  handleDateChange = (e) => {
    const { name, value } = e.target;
    if (name === 'start_date' && dayjs(value).isAfter(this.state.end_date)) {
      this.setState({ [name]: value, end_date: value });
    } else if (
      name === 'end_date' &&
      dayjs(value).isBefore(this.state.start_date)
    ) {
      this.setState({ [name]: value, start_date: value });
    } else {
      this.setState({ [name]: value });
    }
  };

  handleQuickSearch = (e) => {
    if (e.target.value === '' || e.target.value === '0') {
      return;
    }
    this.setState({ limit: e.target.value, offset: 1 }, function () {
      this.getLiveMemoList();
    });
  };

  getLiveMemoList = () => {
    services
      .getLiveMemoList(this.state)
      .then((response) => {
        this.setState({
          liveMemoList: response.data.data.results,
          loading: false,
          count: response.data.data.count,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  resetFilter = () => {
    this.setState(
      {
        start_date: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
        end_date: dayjs().format('YYYY-MM-DD'),
        limit: 20,
        offset: 1,
        count: 0,
      },
      function () {
        this.getLiveMemoList();
      },
    );
  };

  confirmDelete = (item) => {
    confirmAlert({
      title: 'Confirm live memo deletion',
      message: 'Are you sure',
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.deleteItem(item),
        },
        {
          label: 'No',
          onClick: () => false,
        },
      ],
    });
  };

  deleteItem = (item) => {
    const headers = authHeader(1);
    axios
      .delete(
        `${process.env.API_URL}/credit-customer/bunk/live-memo/?memo_id=${item.uuid}`,
        {
          headers,
        },
      )
      .then(() => {
        toast.success('Live memo deleted successfully');
        this.getLiveMemoList();
      })
      .catch((error) => {
        toast.error('Error deleting memo');
      });
  };

  submitForm = (e) => {
    e.preventDefault();
    this.setState({ loading: true }, function () {
      this.getLiveMemoList();
    });
  };

  render() {
    const { liveMemoList } = this.state;

     const exportOptions = {
                    fileName: `Live Memo Report  - ${this.state.start_date} to ${this.state.end_date}`,
                    reportName: 'Live Memo Report',
                    reportDate: `Date - ${dayjs(this.state.start_date).format(
                      'D MMM YY',
                    )} to ${dayjs(this.state.end_date).format('D MMM YY')}`,
                    reportQuantity: '',
                    reportSales: '',
                    reportTesting: '',
                    reportBowser: '',
                    reportTotal: '',
                    reportCustomerName: '',
                    reportGst: '',
                    reportOpeningBalance: '',
                    reportClosingBalance: '',
                    reportSaleTotal: '',
                    reportTCSTotal: '',
                  };

    return (
      <section className="widget full-width list-table">
        <header className="list-header">
          <div className="stock-info-headers">
            <h3>Memo List ({this.state.count})</h3>
          </div>
          <div className="action">
            <button className="submit" type="submit" onClick={this.submitForm}>
              Filter
            </button>
            <button
              onClick={this.resetFilter}
              className="reset-filter"
            ></button>
          </div>
          <div className="export-btns">
            <button
              onClick={() => export2Excel(exportOptions)}
              className={`blue-btn btn-with-icon btn-with-icon__excel action-btn ${this.state.exportingExcel ? 'loading' : ''}`}
              title="Export to Excel"
            >
              Export to Excel
            </button>
            <button
              onClick={() => export2PDF(exportOptions)}
              className={`blue-btn btn-with-icon btn-with-icon__pdf action-btn ${this.state.exportingPdf ? 'loading' : ''}`}
              title="Export to PDF"
            >
              Export to PDF
            </button>
          </div>
        </header>
        <main>
          {!this.props.cod && (
            <div className="table-filters">
              <div className="filter-wrapper">
                <div className="filter-group">
                  <label>From date:</label>
                  <input
                    className="cstm-date-input"
                    type="date"
                    value={this.state.start_date}
                    name="start_date"
                    onChange={this.handleDateChange}
                  />
                </div>
                <div className="filter-group">
                  <label>To date:</label>
                  <input
                    className="cstm-date-input"
                    type="date"
                    value={this.state.end_date}
                    min={this.state.start_date}
                    onChange={this.handleDateChange}
                    name="end_date"
                  />
                </div>
              </div>
            </div>
          )}
          <div className="table-wrapper">
            {(() => {
              if (this.state.loading) {
                return <DropLoaderLarge />;
              } else {
                return (
                  <>
                    <TableGrid
                      col={col}
                      row={liveMemoList}
                      offset={this.state.offset}
                      count={this.state.count}
                      limit={this.state.limit}
                      handlePagination={this.handlePagination}
                      onEdit={this.props.onEdit}
                      onDelete={this.confirmDelete}
                      enabledActions={enabledActions}
                      enableExport={false}
                      recordsFilter={this.handleQuickSearch}
                    />
                  </>
                );
              }
            })()}
          </div>
        </main>
      </section>
    );
  }
}

export default GeneratedBillList;
